import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import addEditRecord from 'add_edit_modals'

import { radii, spacing } from '@PipelineDeals/shared-react-components'

import { hideModal } from 'modals/ducks'
import { EMAIL_MODAL } from 'Email/constants'

import styled from 'styled-components'

const Container = styled.div`
  cursor: pointer;
  background-color: ${props => props.theme.colors.blue[50]};   
  color: ${props => props.theme.colors.gray[800]} !important;
  font-weight: 600;
  padding: ${spacing.xxs};
  border: 1px solid ${props => props.theme.colors.blue[50]};
  border-radius: ${radii.xs};
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: ${spacing.xxs};
  min-width: 0;
  max-width: 100%;
`

const EmailText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`

const Icons = styled.span`
  display: flex;
  gap: ${spacing.xxs};
  flex-shrink: 0;
`

const AddPersonWidget = ({ person, onPersonAdded }) => {
  const dispatch = useDispatch()

  const addPersonModal = (personObj) => {
    let firstName, lastName

    if (personObj.name) {
      const names = personObj.name.split(' ')
      firstName = names[0]
      lastName = names.splice(1).join(' ')
    } else {
      firstName = ''
      lastName = ''
    }

    const personValues = {
      first_name: firstName,
      last_name: lastName,
      email: personObj.email
    }

    addEditRecord({ resourceType: 'person', values: personValues, formMeta: { onSuccess: onPersonAdded } })
  }

  const getCallbackFor = (person) => {
    return (e) => {
      dispatch(hideModal({ type: EMAIL_MODAL }))
      addPersonModal(person)
      e.stopPropagation()
    }
  }

  return (
    <Container onClick={getCallbackFor(person)}>
      <EmailText>{person.email}</EmailText>
      <Icons>
        <i className="fas fa-plus" />
        <i className="fas fa-user" />
      </Icons>
    </Container>
  )
}

AddPersonWidget.displayName = 'Email.Connect.EmailReply.AddPersonWidget'

AddPersonWidget.propTypes = {
  person: PropTypes.object,
  onPersonAdded: PropTypes.func
}

export default AddPersonWidget
